import React from 'react'

function TenderTextSCFHightec() {
  return (
    <embed src="\pdfs\EA1.1.2_scf-hightec_08.2013-kr.pdf" width="100%" height="2100px" />
  )
}

export default TenderTextSCFHightec